import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'antd'
import Header from './components/Layout/Header'
import Footer from './components/Layout/Footer'
import Home from './pages/Home'
import Search from './pages/Search'
import BookList from './pages/BookList'
import BookReader from './pages/BookReader'
import Category from './pages/Category'
import Admin from './pages/Admin'
import './App.css'

const { Content } = Layout

function App() {
  return (
    <Layout className="app-layout">
      <Header />
      <Content className="app-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/category/:categoryId" element={<Category />} />
          <Route path="/books" element={<BookList />} />
          <Route path="/books/:bookId" element={<BookReader />} />
          <Route path="/books/:bookId/page/:pageNumber" element={<BookReader />} />
          <Route path="/admin/*" element={<Admin />} />
        </Routes>
      </Content>
      <Footer />
    </Layout>
  )
}

export default App